/* ==========================================================================
   REAVERFIT — Footer Dropdown Mobile JavaScript
   ========================================================================== */

document.addEventListener('DOMContentLoaded', function() {
  // Sélectionner tous les toggles de dropdown du footer
  const footerDropdownToggles = document.querySelectorAll('.footer-dropdown-toggle');
  
  // Ouvrir la section newsletter par défaut sur mobile
  footerDropdownToggles.forEach((toggle, index) => {
    // Si c'est le dernier toggle (newsletter), l'ouvrir par défaut
    if (index === footerDropdownToggles.length - 1) {
      toggle.setAttribute('aria-expanded', 'true');
    } else {
      toggle.setAttribute('aria-expanded', 'false');
    }
    
    toggle.addEventListener('click', function() {
      const isExpanded = this.getAttribute('aria-expanded') === 'true';
      
      // Fermer tous les autres dropdowns
      footerDropdownToggles.forEach(otherToggle => {
        if (otherToggle !== this) {
          otherToggle.setAttribute('aria-expanded', 'false');
        }
      });
      
      // Basculer l'état du dropdown actuel
      this.setAttribute('aria-expanded', !isExpanded);
    });
  });
});
